import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetOfferingStatusService {

  constructor(private http: HttpClient) {}

  async getOfferingStatus() {
    try { 
      let response = await this.http
        .get(`${appApiResources.getOfferingStatus}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}
